export const PermissionsConstants = Object.freeze({
    VIEW: "view",
    LIST: "list",
    CREATE: "create",
    EDIT: "edit",
    EXPORT: "export",
    FILTER: "filter",
    DELETE: "delete",
    CHANGE_PRICE: "change-price",
    UPLOAD: "upload",
    SEARCH: "search",
    PRODUCT: "product",
    INVOICE: "invoice",
    SHOPS_MAP: "shops_map",
    SHOP: "shop",
    CLIENT: "client",
    EXPORT_CLIENT: "export_client",
    UNMATCHED_SHOP: "unmatched_shop",
    RULES: "rules",
    WORK_ORDER: "work_order",
    USER: "user",
    LOG: "log",
    CAMPAIGN: "campaign",
    SHIPMENT: "shipment",
    ANALYSIS: "analysis",
    PRICE_MONITORING: "price_monitoring",
    TAG: "tag",
    RECIPE: "recipe",
    ROLE_USER: "user",
    ROLE_ADMIN: "admin",
    ROLE_OPERATOR: "operator",
    ROLE_HEAD_OF_SHIFT: "head_of_shift",
    ROLE_LINE_WORKER: "line_worker",
    PERMISSIONS_ADMIN_PRODUCT_GROUP: "admin_product",
    PERMISSIONS_ADMIN_SALES_GROUP: "admin_sales",
    PERMISSIONS_ADMIN_WAREHOUSE_GROUP: "admin_warehouse",
    ROLE_SUPERADMIN: "superadmin"
});
